export function getKeys(enumObj: object) {
  return Object.keys(enumObj).reduce((prev, next) => {
    if (isNaN(Number(next))) {
      prev.push(next);
    }

    return prev;
  }, [] as string[]);
}
